import { put, takeEvery } from 'redux-saga/effects';
import {
  NMAxiosInst,
  SagaRegistry,
  setAlertAndLoading,
  requestHandler,
} from '@neumetric/blueprint-lib/store';
import { DateTimeUtil } from '@neumetric/blueprint-lib/utility';
import { eduActions } from './slice';

function* fetchCirculars({ payload }) {
  yield requestHandler(
    function* () {
      const { pageNo, search, status } = payload;
      const body = { circular: { ...(search || {}), status } };
      const res = yield NMAxiosInst.post(
        `/educators/circular_search?page=${pageNo}&per_page=10`,
        body,
      );
      let circulars = res.circular_list ? res.circular_list : res;
      let totalCount = res.total_count ? res.total_count : circulars.length;
      circulars = Array.isArray(circulars) ? circulars : [];
      circulars.sort(DateTimeUtil.sorterCB.bind(null, 'created_at', 'created_at'));
      circulars = circulars.map((_) => {
        let cir = { ..._ };
        cir.created_at = new DateTimeUtil(cir.created_at).toDateFullYearString();
        cir.link = `${_.guid || _.id}/edit`;
        cir.action = 'Edit';
        return cir;
      });
      yield put(eduActions.setCirculars({ [status]: { rows: circulars, totalCount } }));
    },
    { errorMessage: 'Failed to load Circulars' },
  );
}
function* fetchEvaluations({ payload }) {
  yield requestHandler(
    function* () {
      const { pageNo, search, status } = payload;
      const body = { evaluation: { ...(search || {}), status } };
      const res = yield NMAxiosInst.post(
        `/educators/evaluation_search?page=${pageNo}&per_page=10`,
        body,
      );
      let evaluations = res.evaluation_list ? res.evaluation_list : res;
      evaluations = Array.isArray(evaluations) ? evaluations : [];
      let totalCount = res.total_count ? res.total_count : evaluations.length;
      evaluations.sort(DateTimeUtil.sorterCB.bind(null, 'created_at', 'created_at'));
      evaluations = evaluations.map((_) => {
        let ev = { ..._ };
        ev.created_at = new DateTimeUtil(ev.created_at).toDateFullYearString();
        return ev;
      });
      yield put(
        eduActions.setEvaluations({
          [status]: { rows: evaluations, totalCount },
        }),
      );
    },
    { errorMessage: 'Failed to load evaluations' },
  );
}
function* fetchLearnings({ payload }) {
  yield requestHandler(
    function* () {
      const { pageNo, search, status } = payload;
      const body = { learning: { ...(search || {}), status } };
      const res = yield NMAxiosInst.post(
        `/educators/learning_search?page=${pageNo}&per_page=10`,
        body,
      );
      let active = [],
        inactive = [],
        archive = [];
      let learnings = res.learning_list ? res.learning_list : res;
      let totalCount = res.total_count ? res.total_count : learnings.length;
      learnings = Array.isArray(learnings) ? learnings : [];
      learnings.sort(DateTimeUtil.sorterCB.bind(null, 'created_at', 'created_at'));
      learnings = learnings.map((_, i) => {
        let ev = { ..._ };
        ev.title = _.name || `Learning 0${i + 1}`;
        ev.created_at = new DateTimeUtil(ev.created_at).toDateFullYearString();
        return ev;
      });
      yield put(eduActions.setLearnings({ [status]: { rows: learnings, totalCount } }));
    },
    { errorMessage: 'Failed to load learnings' },
  );
}
function* fetchAssessmentById({ payload }) {
  yield requestHandler(
    function* () {
      const res = yield NMAxiosInst.post('/educators/evaluation_questions', payload);
      yield put(eduActions.setCurrentContent(res));
    },
    { errorMessage: 'Failed to load assessment' },
  );
}
function* fetchLearningById({ payload }) {
  yield requestHandler(
    function* () {
      const res = yield NMAxiosInst.get(`/educators/show_learning?learning_id=${payload.id}`);
      if (
        res &&
        res.learn_type === 'presentation' &&
        Array.isArray(res.attachments) &&
        res.attachments.length > 0
      ) {
        if (res.attachments[0].evidence_url) {
          let url = `/educators/s3_download_file?url=${res.attachments[0].evidence_url}`;
          res.attachments[0].evidence_url_full = NMAxiosInst.getFullPath(url);
          res.attachments[0].blob = yield fetch(res.attachments[0].evidence_url_full, {
            method: 'GET',
            headers: NMAxiosInst.getHeaders(),
          }).then((_) => _.blob());
        }
      }
      yield put(eduActions.setCurrentContent(res));
    },
    { errorMessage: 'Failed to load learnings' },
  );
}
function* fetchCircularById({ payload }) {
  yield requestHandler(
    function* () {
      const res = yield NMAxiosInst.get(`/educators/show_circular?circular_id=${payload.id}`);
      yield put(eduActions.setCurrentContent(res));
    },
    { errorMessage: 'Failed to load Circular' },
  );
}
function* addNewCircular({ payload }) {
  yield requestHandler(
    function* () {
      yield NMAxiosInst.post(
        '/educators/create_circular',
        payload,
        NMAxiosInst.getFormDataContentType(),
      );
      yield put(eduActions.fetchCirculars({ status: 'active', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Circular Created Successfully.',
      });
    },
    { errorMessage: 'Failed to add new Circular' },
  );
}
function* addNewEvaluation({ payload }) {
  yield requestHandler(
    function* () {
      const { upload, ...body } = payload;
      yield NMAxiosInst.post('/educators/create_evaluation', body);
      yield put(eduActions.fetchEvaluations({ status: 'active', pageNo: 1 }));
      let message = 'Assessment Created Successfully.';
      if (upload) {
        message = 'Upload Successfully.;Assessment Created Successfully.';
      }
      yield setAlertAndLoading(null, { message: message });
    },
    { errorMessage: 'Failed to add new assessment' },
  );
}
function* addNewLearning({ payload }) {
  yield requestHandler(
    function* () {
      yield NMAxiosInst.post(
        '/educators/create_learning',
        payload,
        NMAxiosInst.getFormDataContentType(),
      );
      yield put(eduActions.fetchLearnings({ status: 'active', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Learning Created Successfully.',
      });
    },
    { errorMessage: 'Failed to add new learning' },
  );
}
function* updateCircular({ payload }) {
  yield requestHandler(
    function* () {
      yield NMAxiosInst.put(
        '/educators/edit_circular',
        payload,
        NMAxiosInst.getFormDataContentType(),
      );
      yield put(eduActions.fetchCirculars({ status: 'active', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Circular Updated Successfully.',
      });
    },
    { errorMessage: 'Failed to update Circular' },
  );
}
function* updateEvaluation({ payload }) {
  yield requestHandler(
    function* () {
      yield NMAxiosInst.post('/educators/update_evaluation', payload);
      yield put(eduActions.fetchEvaluations({ status: 'active', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Assessment Updated Successfully.',
      });
    },
    { errorMessage: 'Failed to save assessment' },
  );
}
function* updateLearning({ payload }) {
  yield requestHandler(
    function* () {
      yield NMAxiosInst.put(
        '/educators/edit_learning',
        payload,
        NMAxiosInst.getFormDataContentType(),
      );
      yield put(eduActions.fetchLearnings({ status: 'active', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Learning Updated Successfully.',
      });
    },
    { errorMessage: 'Failed to save learning' },
  );
}
function* archiveLearning({ payload }) {
  yield requestHandler(
    function* () {
      const { id } = payload;
      const body = new FormData();
      body.append('learning_id', id);
      body.append('learning[status]', 'archive');
      yield NMAxiosInst.put('/educators/edit_learning', body, NMAxiosInst.getFormDataContentType());
      yield setAlertAndLoading(null, {
        message: 'Learning Archived Successfully.',
      });
    },
    { errorMessage: 'Failed to archive learning' },
  );
}
function* archiveCircular({ payload }) {
  yield requestHandler(
    function* () {
      const { id } = payload;
      const body = new FormData();
      body.append('circular_id', id);
      body.append('circular[status]', 'archive');
      yield NMAxiosInst.put('/educators/edit_circular', body, NMAxiosInst.getFormDataContentType());
      yield put(eduActions.fetchCirculars({ status: 'active', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Circular Archived Successfully.',
      });
    },
    { errorMessage: 'Failed to archive Circular' },
  );
}
function* archiveEvaluation({ payload }) {
  yield requestHandler(
    function* () {
      const { id } = payload;
      const body = { evaluation: { id, status: 'archive' } };
      yield NMAxiosInst.post('/educators/update_evaluation', body);
      yield put(eduActions.fetchEvaluations({ status: 'active', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Assessment Archived Successfully.',
      });
    },
    { errorMessage: 'Failed to archive Assessment' },
  );
}
function* unArchiveLearning({ payload }) {
  yield requestHandler(
    function* () {
      const { id } = payload;
      const body = new FormData();
      body.append('learning_id', id);
      body.append('learning[status]', 'active');
      yield NMAxiosInst.put('/educators/edit_learning', body, NMAxiosInst.getFormDataContentType());
      yield put(eduActions.fetchLearnings({ status: 'archive', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Learning Unarchived Successfully.',
      });
    },
    { errorMessage: 'Failed to unarchive learning' },
  );
}
function* unArchiveCircular({ payload }) {
  yield requestHandler(
    function* () {
      const { id } = payload;
      const body = new FormData();
      body.append('circular_id', id);
      body.append('circular[status]', 'active');
      yield NMAxiosInst.put('/educators/edit_circular', body, NMAxiosInst.getFormDataContentType());
      yield put(eduActions.fetchCirculars({ status: 'archive', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Circular Unarchived Successfully.',
      });
    },
    { errorMessage: 'Failed to unarchive circular' },
  );
}
function* unArchiveAssessment({ payload }) {
  yield requestHandler(
    function* () {
      const { id } = payload;
      const body = { evaluation: { id, status: 'active' } };
      yield NMAxiosInst.post('/educators/update_evaluation', body);
      yield put(eduActions.fetchEvaluations({ status: 'active', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Assessment Unarchived Successfully.',
      });
    },
    { errorMessage: 'Failed to unarchive assessment' },
  );
}
function* deleteLearning({ payload }) {
  yield requestHandler(
    function* () {
      yield NMAxiosInst.post('/educators/soft_delete_for_learning', {
        learning_id: payload.id,
      });
      yield put(eduActions.fetchLearnings({ status: 'active', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Learning Deactivated Successfully.',
      });
    },
    { errorMessage: 'Failed to delete learning' },
  );
}
function* deleteCircular({ payload }) {
  yield requestHandler(
    function* () {
      yield NMAxiosInst.post('/educators/soft_delete_for_circular', {
        circular_id: payload.id,
      });
      yield put(eduActions.fetchCirculars({ status: 'active', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Circular Deactivated Successfully.',
      });
    },
    { errorMessage: 'Failed to delete Circular' },
  );
}
function* deleteEvaluation({ payload }) {
  yield requestHandler(
    function* () {
      yield NMAxiosInst.post('/educators/soft_delete_for_evaluation', {
        evaluation_id: payload.id,
      });
      yield put(eduActions.fetchEvaluations({ status: 'active', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Assessment Deactivated Successfully.',
      });
    },
    { errorMessage: 'Failed to delete Assessment' },
  );
}
function* activateLearning({ payload }) {
  yield requestHandler(
    function* () {
      const body = new FormData();
      body.append('learning_id', payload.id);
      body.append('learning[status]', 'active');
      yield NMAxiosInst.put('/educators/edit_learning', body, NMAxiosInst.getFormDataContentType());
      yield put(eduActions.fetchLearnings({ status: 'deleted', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Learning activated successfully.',
      });
    },
    { errorMessage: 'Failed to activate learning' },
  );
}
function* activateCircular({ payload }) {
  yield requestHandler(
    function* () {
      const body = new FormData();
      body.append('circular_id', payload.id);
      body.append('circular[status]', 'active');
      yield NMAxiosInst.put('/educators/edit_circular', body, NMAxiosInst.getFormDataContentType());
      yield put(eduActions.fetchCirculars({ status: 'deleted', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Circular activated successfully.',
      });
    },
    { errorMessage: 'Failed to activate circular' },
  );
}
function* activateEvaluation({ payload }) {
  yield requestHandler(
    function* () {
      const body = { evaluation: { id: payload.id, status: 'active' } };
      yield NMAxiosInst.post('/educators/update_evaluation', body);
      yield put(eduActions.fetchEvaluations({ status: 'deleted', pageNo: 1 }));
      yield setAlertAndLoading(null, {
        message: 'Assement activated successfully.',
      });
    },
    { errorMessage: 'Failed to activate assessment' },
  );
}
function* fetchOrganisationsForScheduler() {
  yield requestHandler(
    function* () {
      const res = yield NMAxiosInst.get('/EC/organisations');
      yield put(eduActions.setOrganisationsForScheduler(res?.organisations));
    },
    { errorMessage: 'Failed to load organisations' },
  );
}
function* fetchUsersForScheduler({ payload }) {
  const { org_id } = payload;

  yield requestHandler(
    function* () {
      const res = yield NMAxiosInst.get(`/EC/users_for_org?org_id=${org_id}`);
      yield put(eduActions.setUsersForScheduler(res?.users));
    },
    { errorMessage: 'Failed to load users' },
  );
}
function* fetchActionsForScheduler() {
  yield requestHandler(
    function* () {
      const res = yield NMAxiosInst.get('/EC/actions');
      yield put(eduActions.setActionsForScheduler(res?.actions));
    },
    { errorMessage: 'Failed to load actions' },
  );
}
const buildName = (user) => {
  const first = (user?.firstname || '').trim();
  const last = (user?.lastname || '').trim();
  const lastInitial = last ? `${last[0].toUpperCase()}.` : '';
  return `${first}${lastInitial ? ' ' + lastInitial : ''}`.trim();
};

function* fetchListOfEducatorItems({ payload }) {
  yield requestHandler(
    function* () {
      const res = yield NMAxiosInst.post(`/EC/educatornotifi`, payload);
      const list = res?.data || [];
      const rows = (Array.isArray(list) ? list : []).map((item) => {
        const triggerable = item?.triggerable || {};
        const user = item?.user || {};
        const status = item?.actual_trigger_at ? 'success' : 'failed';
        return {
          key: item?.id,
          id: item?.id,
          title: triggerable?.title || triggerable?.name || '-',
          trigger_at: new DateTimeUtil(item?.trigger_at).toDateFullYearString() || '-',
          name: buildName(user),
          email: user?.email || '-',
          status: status || '-',
        };
      });

      yield put(
        eduActions.setEducatorScheduleList({
          rows,
          total_records: res?.data?.total_records || 0,
          page: res?.data?.page || 1,
          per_page: res?.data?.per_page || 25,
        }),
      );
    },
    { errorMessage: 'Failed to load schedule list' },
  );
}
function* triggerEducatorItems({ payload }) {
  yield requestHandler(function* () {
    yield NMAxiosInst.post(`/EC/re_trigger`, payload);
  });
}

SagaRegistry.register(function* userSaga() {
  yield takeEvery('edu/fetchCirculars', fetchCirculars);
  yield takeEvery('edu/fetchEvaluations', fetchEvaluations);
  yield takeEvery('edu/fetchLearnings', fetchLearnings);
  yield takeEvery('edu/addNewCircular', addNewCircular);
  yield takeEvery('edu/addNewEvaluation', addNewEvaluation);
  yield takeEvery('edu/addNewLearning', addNewLearning);
  yield takeEvery('edu/updateCircular', updateCircular);
  yield takeEvery('edu/updateEvaluation', updateEvaluation);
  yield takeEvery('edu/updateLearning', updateLearning);
  yield takeEvery('edu/archiveCircular', archiveCircular);
  yield takeEvery('edu/archiveEvaluation', archiveEvaluation);
  yield takeEvery('edu/archiveLearning', archiveLearning);
  yield takeEvery('edu/unArchiveLearning', unArchiveLearning);
  yield takeEvery('edu/unArchiveCircular', unArchiveCircular);
  yield takeEvery('edu/unArchiveAssessment', unArchiveAssessment);
  yield takeEvery('edu/deleteCircular', deleteCircular);
  yield takeEvery('edu/deleteEvaluation', deleteEvaluation);
  yield takeEvery('edu/deleteLearning', deleteLearning);
  yield takeEvery('edu/activateCircular', activateCircular);
  yield takeEvery('edu/activateEvaluation', activateEvaluation);
  yield takeEvery('edu/activateLearning', activateLearning);
  yield takeEvery('edu/fetchAssessmentById', fetchAssessmentById);
  yield takeEvery('edu/fetchLearningById', fetchLearningById);
  yield takeEvery('edu/fetchCircularById', fetchCircularById);
  yield takeEvery('edu/fetchOrganisationsForScheduler', fetchOrganisationsForScheduler);
  yield takeEvery('edu/fetchUsersForScheduler', fetchUsersForScheduler);
  yield takeEvery('edu/fetchActionsForScheduler', fetchActionsForScheduler);
  yield takeEvery('edu/fetchListOfEducatorItems', fetchListOfEducatorItems);
  yield takeEvery('edu/triggerEducatorItems', triggerEducatorItems);
});
